export default {
  minCosts: {
    data: [],
    loading: false,
    error: null
  }
}
